import React from "react";
import { Container, Typography, Box } from "@mui/material";

interface HeroSection {
  title: string;
  description: string;
}

// HeroSectionCard Component
const HeroSectionCard: React.FC<HeroSection> = ({ title, description }) => {
  return (
    <Box
      sx={{
        padding: { xs: "50px 20px 30px", md: "70px 20px 40px" },
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        <Box
          className="glass-panel"
          sx={{
            padding: { xs: "30px 20px", md: "50px 40px" },
            background: "rgba(30, 41, 59, 0.5)",
            borderRadius: "28px",
            border: "1px solid rgba(255, 255, 255, 0.12)",
          }}
        >
          <Typography
            variant="h2"
            className="gradient-text"
            sx={{
              fontWeight: 800,
              fontSize: { xs: "2rem", sm: "2.8rem", md: "3.5rem" },
              letterSpacing: "-1px",
              marginBottom: "20px",
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "#94a3b8",
              fontSize: { xs: "1rem", md: "1.2rem" },
              lineHeight: 1.7,
              maxWidth: "900px",
              margin: "0 auto",
              fontWeight: 400,
            }}
          >
            {description}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export const MultiFaceSwapHeroSection: React.FC = () => (
  <HeroSectionCard
    title="What is Multi-Face Swap?"
    description="Multi-face swap is an AI-based photo editing tool that lets you swap multiple faces in one image, making it perfect for group photos. Whether you want to switch faces in a family photo, swap identities with friends, or try hilarious couple swaps, SwapToon makes it easy and fun! With advanced AI face detection, our system accurately maps and replaces faces, ensuring realistic, high-resolution face swaps with natural-looking blends."
  />
);

export const SingleFaceSwapHeroSection: React.FC = () => (
  <HeroSectionCard
    title="What is SwapToon?"
    description="SwapToon is an AI-powered face swap app that allows you to seamlessly
          swap faces in photos. Whether you want to create funny images,
          transform yourself into a cartoon, or experiment with different looks,
          our app makes it fast, easy, and fun."
  />
);

export const PreweddingHeroSection: React.FC = () => (
  <HeroSectionCard
    title="What is Pre-Wedding AI Face Swap?"
    description="Pre-Wedding AI Face Swap is a specialized tool that allows couples to place their faces into stunning pre-wedding photo concepts, romantic shoot themes, and high-fashion wedding attire. Whether you are planning your wedding, experimenting with creative themes, or simply creating romantic couple portraits, SwapToon makes pre-wedding photo swapping effortless, realistic, and magical."
  />
);

export const BabyshowerHeroSection: React.FC = () => (
  <HeroSectionCard
    title="What is Baby Shower AI Face Swap?"
    description="Baby Shower AI Face Swap is an intelligent tool designed to transform family, pregnancy announcement, and baby shower photos! Place parents-to-be, family members, and friends into adorable baby shower themes, gender reveal concepts, and maternity photoshoot templates effortlessly with SwapToon's advanced AI face swap engine."
  />
);
